import type {TravelType} from '@/modules/common/context/QueryParams/models';
import type {SearchFormValues} from '@travel-frontend/ui-components';

import {useSearchFormDefaultValues as useSearchFormDefaultValuesShared} from '@travel-frontend/ui-components';
import {useMemo} from 'react';

import {config} from '@/config';
import {useLocalSplit} from '@/modules/common/hooks';

type UseSearchFormDefaultValuesProps = {
  travelType: TravelType;
};

type UseSearchFormDefaultValuesReturnValue = SearchFormValues;

export const useSearchFormDefaultValues = ({
  travelType,
}: UseSearchFormDefaultValuesProps): UseSearchFormDefaultValuesReturnValue => {
  const durationPickerSplitEnabled =
    useLocalSplit('FSE_3060_new_datepicker').treatment === 'on';

  const travelPeriod = useMemo(() => {
    let duration: {min: number; max: number} =
      config.travelPeriod.duration[travelType];

    if (durationPickerSplitEnabled) {
      duration = config.travelPeriod.durationNext[travelType];
    }

    return {
      period: config.travelPeriod.period,
      duration,
    };
  }, [durationPickerSplitEnabled, travelType]);

  return useSearchFormDefaultValuesShared({
    airports: config.airports,
    travelPeriod,
  });
};
